<h2 i18n="@@titleAdmin">Admin</h2>

<app-admin-groups />
<app-admin-users />
